import { useContext } from 'react';
import cx from 'classnames';

import Content from 'Storybook/local/Content/Content';

import { AppContext } from '../../contexts/AppContext';
import { getObjectValue } from '../../utilities/helpers';
import SignUpSidebar from '../SignUpSidebar/SignUpSidebar';

import Texts from './StaticContents/index';

import styles from './StaticPages.module.scss';

type StaticPagesProps = {
	fullWidth?: boolean;
	signUpSidebar: boolean;
	slug: keyof typeof Texts;
};

const StaticPages: React.FC<StaticPagesProps> = (props) => {
	const { fullWidth = false, signUpSidebar = true, slug } = props;
	const context = useContext(AppContext);
	const user = getObjectValue(context, 'state.user');
	const StaticPage = Texts[slug] || (() => null);

	return (
		<Content
			className={cx(styles.content, styles.StaticPages, { [styles.hidden]: false })}
			wrapper={{ className: styles.contentWrapper }}
		>
			<div className={cx(styles.container, { [styles.containerFull]: !signUpSidebar, [styles.fullWidth]: fullWidth })}>
				<StaticPage />
			</div>
			{!user && signUpSidebar && <SignUpSidebar />}
		</Content>
	);
};

export default StaticPages;
